module.exports = __webpack_public_path__ + "static/media/elDorado.706e49ca.svg";